import { render, staticRenderFns } from "./DetectionHistory.vue?vue&type=template&id=90371f90&scoped=true"
import script from "./DetectionHistory.vue?vue&type=script&lang=js"
export * from "./DetectionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90371f90",
  null
  
)

export default component.exports